import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { RouteEvent } from '@commons/models/domain/RouteEvent';

@Component({
  selector: 'app-route-line',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './route-line.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./route-line.component.scss'],
})
export class RouteLineComponent {
  @Input() public routeData: RouteEvent;
}
